import { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { AbonnementCard } from "../card/abonnementCard";
import { enumChooseSubscription } from "../../enums/enumChooseSubscription";
import EntrepriseService from "../../services/entrepriseService";
import { ProgressSpinner } from "primereact/progressspinner";
import { useAuthState } from "../../context/context";
import StripeHelper from "../../utils/stripeHelper";
import "./companyChooseSubscription.css";

export const CompanyChooseSubscription = (props) => {

    const { t } = useTranslation()
    const currentUser = useAuthState();
    const [loading, setLoading] = useState(true);
    const [allSubscription, setAllSubscription] = useState(null);
    const [currentStepSubscription, setCurrentStepSubscription] = useState(null);

    // Déplacer fonction dans AbonnementService
    const entrepriseService = new EntrepriseService();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setLoading(true);
        // on défini l'abonnement actuel de l'entreprise
        setCurrentStepSubscription(props.entreprise.abonnementEntreprise.code);
        // on récupère tout les type d'abonnement possible puis on place devant chaque objet son code afin de l'appeler plus facilement
        entrepriseService.getAbonnementEntreprise().then((_subscriptions) => {
            let sortedSubscriptions = []
            _subscriptions.forEach((subscription) => {
                sortedSubscriptions[subscription.code] = subscription;
            })
            setAllSubscription(sortedSubscriptions);
        }).catch((error) => {
            // A MODIFER
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }

    const onOpenSubscriptionClick = (subscriptionLink, enumSubscriptionCode) => {
        // on récupère le lien de la page de souscription de l'abonnement et on l'ouvre dans un nouvel onglet que l'on focus
        if (currentUser?.user?.email) {
            subscriptionLink = StripeHelper.addPrefilledEmail(subscriptionLink, currentUser.user.email)
            if (props.entreprise?.codePartenariat) {
                // temporary code for promotion code
                if (ApplyPartnershipCodeFilter(props.entreprise.codePartenariat, enumSubscriptionCode)){
                    subscriptionLink = StripeHelper.addPrefilledPromoCode(subscriptionLink, props.entreprise.codePartenariat)
                }
            }
        }
        var win = window.open(subscriptionLink)
        win.focus();
    }

    const onClickContact = () => {
        var win = window.open("https://meetings.hubspot.com/patrick-musso/visio-patrick-musso")
        win.focus();
    }

    const ApplyPartnershipCodeFilter = (codeName, subscriptionCode) => {
        if (!codeName || typeof codeName !== 'string') {
            return false;
        }
    
        codeName = codeName.toUpperCase();
        switch (codeName) {
            case "DECOUVERTE":
                return subscriptionCode === enumChooseSubscription.CASUAL;
            case "UPE06":
                return (
                    subscriptionCode === enumChooseSubscription.CASUAL || 
                    subscriptionCode === enumChooseSubscription.REGULAR
                );
            default:
                return false;
        }
    };

    return (
        <>
            {loading ? (
                <div className="p-d-flex p-jc-center p-ai-center" style={{ height: "50vh" }}>
                    <ProgressSpinner />
                </div>
            ) : (
                <>
                    <div className="p-grid dip-jc-center ccs-container-abonnement-cards">
                        <div className="p-col-12 p-sm-12 p-lg-4">
                            <AbonnementCard
                                title={t("subscription.offers.offer_freemium")}
                                enumChooseSubscription={enumChooseSubscription.FREEMIUM}
                                isCurrent={currentStepSubscription == enumChooseSubscription.FREEMIUM}
                                free
                            />
                        </div>

                        <div className="p-col-12 p-sm-12 p-lg-4">
                            <AbonnementCard
                                title="Offre Recruteur"
                                enumChooseSubscription={enumChooseSubscription.REGULAR}
                                pricingOptions={allSubscription?.[enumChooseSubscription.REGULAR]?.options || [
                                    { label: '60 contacts / mois', price: allSubscription?.[enumChooseSubscription.CASUAL]?.tarifMensuel || 79, stripeMonthlyCheckoutUrl: allSubscription?.[enumChooseSubscription.CASUAL]?.stripeMonthlyCheckoutUrl },
                                    { label: '240 contacts / mois', price: allSubscription?.[enumChooseSubscription.REGULAR]?.tarifMensuel || 229, stripeMonthlyCheckoutUrl: allSubscription?.[enumChooseSubscription.REGULAR]?.stripeMonthlyCheckoutUrl }
                                ]}
                                partnershipName={props.entreprise.codePartenariat}
                                partnershipCode={ApplyPartnershipCodeFilter(props.entreprise.codePartenariat, enumChooseSubscription.REGULAR) ? props.entreprise.codePromo : null}
                                buttonLabel={t("subscription.subscribe")}
                                abonnementType={currentStepSubscription}
                                onClick={(selectedOption) => {
                                    const url = selectedOption?.stripeCheckoutUrl || selectedOption?.stripeMonthlyCheckoutUrl || selectedOption?.stripeAnnualCheckoutUrl || allSubscription[enumChooseSubscription.REGULAR]?.stripeMonthlyCheckoutUrl;
                                    // Determine subscriptionCode: prefer explicit subscriptionCode field
                                    let subscriptionCode = selectedOption?.subscriptionCode;

                                    // If the API provided the option without subscriptionCode, infer from label
                                    if (!subscriptionCode) {
                                        const label = (selectedOption?.label || '').toString().toLowerCase();
                                        if (label.includes('60') || label.includes('casual') || label.includes('découverte') || label.includes('decouverte')) {
                                            subscriptionCode = enumChooseSubscription.CASUAL;
                                        } else if (label.includes('240') || label.includes('regular') || label.includes('recruteur')) {
                                            subscriptionCode = enumChooseSubscription.REGULAR;
                                        }
                                    }

                                    // Fallback: try matching by price
                                    if (!subscriptionCode) {
                                        const price = Number(selectedOption?.price);
                                        const casualPrice = Number(allSubscription?.[enumChooseSubscription.CASUAL]?.tarifMensuel || allSubscription?.[enumChooseSubscription.CASUAL]?.tarif);
                                        const regularPrice = Number(allSubscription?.[enumChooseSubscription.REGULAR]?.tarifMensuel || allSubscription?.[enumChooseSubscription.REGULAR]?.tarif || allSubscription?.[enumChooseSubscription.REGULAR]?.tarifAnnuel);
                                        if (!isNaN(price) && !isNaN(casualPrice) && price === casualPrice) {
                                            subscriptionCode = enumChooseSubscription.CASUAL;
                                        } else if (!isNaN(price) && !isNaN(regularPrice) && price === regularPrice) {
                                            subscriptionCode = enumChooseSubscription.REGULAR;
                                        } else {
                                            subscriptionCode = enumChooseSubscription.REGULAR; // safe default
                                        }
                                    }

                                    onOpenSubscriptionClick(url, subscriptionCode);
                                }}
                                inputSwitchChecked={true}
                                searchNextBillingDate={currentStepSubscription == enumChooseSubscription.REGULAR || currentStepSubscription == enumChooseSubscription.CASUAL}
                                isCurrent={currentStepSubscription == enumChooseSubscription.REGULAR || currentStepSubscription == enumChooseSubscription.CASUAL}
                            />
                        </div>

                        <div className="p-col-12 p-sm-12 p-lg-4">
                            <AbonnementCard
                                title="Offre Sérénité"
                                enumChooseSubscription={enumChooseSubscription.GRANDCOMPTE}
                                pricingOptions={allSubscription?.[enumChooseSubscription.GRANDCOMPTE]?.options || (
                                    [
                                        { label: 'Stagiaire', price: "180" },
                                        { label: 'Alternant', price: "250" },
                                        { label: 'Junior', price: "1 200" }
                                    ]
                                )}
                                buttonLabel={t("formation.consult_us")}
                                abonnementType={currentStepSubscription}
                                onClick={() => onClickContact()}
                                isCurrent={currentStepSubscription == enumChooseSubscription.GRANDCOMPTE}
                            />
                        </div>

                    </div>
                </>
                // )
            )}
        </>
    )
}